import { X } from 'lucide-react';
import { Button, Input, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@artstorefronts/ui';
import { useTranslation } from 'react-i18next';

interface FilterState {
  search: string;
  emailSearch: string;
  good?: boolean | null;
  evaluated?: boolean | null;
  from?: string;
  to?: string;
}

interface FiltersProps {
  state: FilterState;
  onUpdate: (key: string, value: any) => void;
  onClear: () => void;
}

function Filters({ state, onUpdate, onClear }: FiltersProps) {
  const { t } = useTranslation('chat');

  return (
    <div className="bg-white p-4 border rounded-lg shadow-xs mb-6">
      <div className="flex items-center gap-4">
        {/* Chat ID Search */}
        <div className="flex-1 min-w-48">
          <Input
            placeholder={t('filters.search-chat-id')}
            value={state.search}
            onChange={(e) => onUpdate('search', e.target.value)}
            className="w-full"
          />
        </div>

        {/* Email Search */}
        <div className="flex-1 min-w-48">
          <Input
            placeholder={t('filters.search-email')}
            value={state.emailSearch}
            onChange={(e) => onUpdate('emailSearch', e.target.value)}
            className="w-full"
          />
        </div>

        {/* Good/Bad Filter */}
        <Select
          value={state.good?.toString() || 'all'}
          onValueChange={(value) => onUpdate('good', value === 'all' ? undefined : value === 'true')}
        >
          <SelectTrigger className="w-32">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t('filters.all')}</SelectItem>
            <SelectItem value="true">{t('filters.good')}</SelectItem>
            <SelectItem value="false">{t('filters.bad')}</SelectItem>
          </SelectContent>
        </Select>

        {/* Evaluated Filter */}
        <Select
          value={state.evaluated?.toString() || 'all'}
          onValueChange={(value) => onUpdate('evaluated', value === 'all' ? undefined : value === 'true')}
        >
          <SelectTrigger className="w-36">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t('filters.all')}</SelectItem>
            <SelectItem value="true">{t('filters.evaluated')}</SelectItem>
            <SelectItem value="false">{t('filters.unevaluated')}</SelectItem>
          </SelectContent>
        </Select>

        {/* Date Range */}
        <Input
          type="date"
          value={state.from || ''}
          onChange={(e) => onUpdate('from', e.target.value)}
          className="w-36"
          placeholder={t('filters.from-date')}
        />

        <Input
          type="date"
          value={state.to || ''}
          onChange={(e) => onUpdate('to', e.target.value)}
          className="w-36"
          placeholder={t('filters.to-date')}
        />

        {/* Clear Button - Icon Only */}
        <Button variant="ghost" onClick={onClear} size="sm" className="px-2">
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}

export default Filters;
